<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            v-on="on"
          >
            <div class="list-item-text">
              <span class="list-item-name">Reset my password</span>
            </div>
          </v-btn>
        </div>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Update password</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="password"
              v-slot="{ errors }"
              name="password"
              rules="required|password"
            >
              <v-text-field
                ref="password"
                v-model="password"
                :error-messages="errors"
                :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                :type="showPassword ? 'text' : 'password'"
                label="New password"
                @click:append="showPassword = !showPassword"
              />
            </ValidationProvider>

            <ValidationProvider
              id="confirm_password"
              v-slot="{ errors }"
              name="confirm_password"
              rules="required|confirmed:password"
            >
              <v-text-field
                v-model="confirmPassword"
                :error-messages="errors"
                :append-icon="
                  showConfirmPassword ? icons.mdiEye : icons.mdiEyeOff
                "
                :type="showConfirmPassword ? 'text' : 'password'"
                label="Confirm new password"
                @click:append="showConfirmPassword = !showConfirmPassword"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-btn
            rounded
            depressed
            :loading="buttonLoading"
            color="primary"
            class="ml-4 mb-1"
            @click="save()"
            ><span>Update</span
            ><v-icon small>{{ icons.mdiArrowRight }}</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { CHANGE_PASSWORD_MUTATION } from '../../constants/graphql/authentication';

  export default {
    name: 'UpdatePassword',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    data() {
      return {
        dialog: false,
        password: null,
        confirmPassword: null,
        showPassword: false,
        showConfirmPassword: false,
        showSuccess: false,
        successMessage: null,
      };
    },
    methods: {
      save() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.updatePassword();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      updatePassword() {
        const password = this.password;
        const id = this.userId;

        this.$apollo
          .mutate({
            mutation: CHANGE_PASSWORD_MUTATION,
            variables: {
              id,
              password,
            },
          })
          .then(response => {
            const accessToken = response.data.changePassword.accessToken;
            const refreshToken = response.data.changePassword.refreshToken;

            this.$store.dispatch('login', { accessToken, refreshToken });
            this.showSuccessMessage();
          })
          .catch(error => {
            this.displayErrorAndCloseDialog();
            throw error;
          });
      },
      showSuccessMessage() {
        this.successMessage = 'Your password has been updated';
        this.showSuccess = true;
        this.closeDialog();
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
        this.$refs.observer.reset();
        setTimeout(() => this.resetDialog(), 300);
      },
      resetDialog() {
        this.password = null;
        this.confirmPassword = null;
      },
    },
  };
</script>
